module.exports = __webpack_public_path__ + "media/images/padlet_logo_rainbow-b74dea3a9f0037bc9e5f0b4f853b851e.png";